import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const NewsItemCardFull = React.forwardRef(({ className, news }, ref) => {
  return (
    <section ref={ref} className={'section__news-item-card-full'}>
      <div className="newsitem-container">
        <div className="ed-container">
          <div className="item-container">
            <div className="image-container">
              <img src={news.linkPhoto}/>
            </div>
            <div className="nicf_principal-container">
              <div className="date-container">
                <h6>{news && news.date ? news.date:'18 de Octubre de 2020'}</h6>
              </div>
              <div className="title-container">
                <h2>{news ? news.title:'' }</h2>
              </div>
              <div className="content-container">
                <p>
                  <div dangerouslySetInnerHTML={{ __html: news ?  news.description: '' }}/>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});

NewsItemCardFull.displayName = 'NewsItemCardFull';

NewsItemCardFull.defaultProps = {
  className: '',
};

NewsItemCardFull.propTypes = {
  className: PropTypes.string,
};

export default NewsItemCardFull;